export enum Status {
  Admitted = 'ADMITTED',
  Discharged = 'DISCHARGED',
  ReadyForStaff = 'READY_FOR_STAFF',
  WithStaff = 'WITH_STAFF',
  ReadyForProvider = 'READY_FOR_PROVIDER',
  WithProvider = 'WITH_PROVIDER',
  CheckedOut = 'CHECKED_OUT',
  Arrived = 'ARRIVED',
  Cancelled = 'CANCELLED',
  NoShow = 'NO_SHOW',
  Scheduled = 'SCHEDULED',
  Unknown = 'UNKNOWN',
}
